import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const ProductSizeGuide: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  const modal = (
    <div className="pd-modal" role="dialog" aria-modal="true" aria-labelledby="size-guide-title" onClick={() => setOpen(false)}>
      <div className="pd-modal__content" onClick={(e) => e.stopPropagation()}>
        <button className="pd-modal__close" onClick={() => setOpen(false)} aria-label="Zavřít">×</button>
        <h2 id="size-guide-title">Jak si správně změřit velikost</h2>
        <p>Pro výběr správné velikosti střihu si vezměte krejčovský metr a změřte se v základních místech. Měřte přímo na těle, ne přes silnější oděv.</p>

        <h3>1. Obvod hrudníku</h3>
        <p>Změřte v nejširším místě hrudníku, metr veďte vodorovně přes záda. Nezpevňujte zhluboka nádech.</p>

        <h3>2. Obvod pasu</h3>
        <p>Změřte v nejužším místě trupu, obvykle těsně nad pupkem. Metr by měl být přiléhavý, ale ne zaříznutý.</p>

        <h3>3. Obvod boků</h3>
        <p>Změřte v nejširším místě boků, přibližně 20 cm pod pasem. Stojte rovně, paty u sebe.</p>

        <h3>4. Dětské velikosti</h3>
        <p>U dětských střihů se velikost obvykle určuje podle výšky dítěte v cm (80, 86, 92, …, 170). Pokud váháte mezi dvěma velikostmi, doporučujeme volit větší — děti rychle vyrostou.</p>

        <div className="pd-modal__tips">
          <strong>Tip:</strong> Velikostní tabulku k tomuto konkrétnímu střihu najdete v záložce <em>Velikostní tabulka</em>. Pokud nejste mezi velikostmi přesně, zvolte tu větší — látka při šití lépe ubere než přidá.
        </div>

        <div className="pd-modal__actions">
          <button className="pd-modal__btn-primary" onClick={() => setOpen(false)}>Rozumím</button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <button type="button" className="pd-sizeguide-btn" onClick={() => setOpen(true)}>
        Jak si změřit
      </button>
      {open && typeof document !== 'undefined' && createPortal(modal, document.body)}
    </>
  );
};

export default ProductSizeGuide;
